import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=0f9d31f5&scoped=true"
import script from "./tag.vue?vue&type=script&lang=js"
export * from "./tag.vue?vue&type=script&lang=js"
import style0 from "./tag.vue?vue&type=style&index=0&id=0f9d31f5&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d31f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f9d31f5')) {
      api.createRecord('0f9d31f5', component.options)
    } else {
      api.reload('0f9d31f5', component.options)
    }
    module.hot.accept("./tag.vue?vue&type=template&id=0f9d31f5&scoped=true", function () {
      api.rerender('0f9d31f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backend/tag.vue"
export default component.exports